<section role="region" class="wrapper--blue training-orientation">
  <div class="training-orientation__main-content">
    <h2 class="training-orientation_title">
      Être accompagné
      <span class="highlight--white">et orienté.</span>
    </h2>
    <p>
      Afin de répondre à vos interrogations et à celles de vos familles, de vous informer et de vous orienter, un seul
      numéro&nbsp;:
    </p>
    <app-training-obligation-phone-number (tracker)="onTrackerClicked('Phone')"></app-training-obligation-phone-number>
    <p>
      Au téléphone, les acteurs de l&apos;orientation et de l&apos;accompagnement répondent en fonction de la région où
      vous habitez, de manière à ce que vous ayez d&apos;emblée en ligne un professionnel de votre région.
    </p>
  </div>
  <div class="training-orientation__info">
    <div class="training-orientation__info__block">
      <app-info-block [infoBlockConfig]="onisepConfig" (tracker)="onTrackerClicked('Nouvelles Chances')">
        <p class="training-orientation__info__block__text">
          Le numéro vert est accompagné d&apos;une plateforme
          <a class="link--primary" href="https://www.nouvelles-chances.gouv.fr" target="_blank"
            >nouvelles-chances.gouv.fr</a
          >
          gérée par l&apos;ONISEP pour informer sur les solutions variées et concrètes adaptées à chaque situation. Elle
          s&apos;adresse à vous et à vos familles ainsi qu&apos;aux acteurs de l&apos;éducation, de l&apos;insertion
          sociale et professionnelle tous mobilisés, ensemble pour que chacun d&apos;entre vous trouve sa place.
        </p>
      </app-info-block>
    </div>
  </div>
</section>
